import { render, staticRenderFns } from "./AboutClientTab.vue?vue&type=template&id=fd578120"
import script from "./AboutClientTab.vue?vue&type=script&lang=js"
export * from "./AboutClientTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports